<template>
  <div class="container flex flex-direction">
    <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
    <div class="flex align-center justify-between top-box">
      <div class="flex-sub top-img-left"></div>
      <div class="top-name">{{ name }}物业数据管理信息</div>
      <div class="flex-sub top-img-right">
        <div class="time-box">
          {{year}}年{{month}}月
          <el-date-picker
            style="position: absolute;top: 0;left: 0;width: 100%;opacity: 0;cursor: pointer;"
            @change="setMonth"
            v-model="time"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="flex align-start justify-between padding">
      <div class="left-info">
        <div class="left-user">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 志愿者队长</span>
            <img src="../../../assets/img/jiantou.png">
          </h3>
          <div class="user-img">
            <img :src="avatar" alt="">
          </div>
          <div class="manager-name">{{ name }}</div>
        </div>

        <div class="flex align-center justify-between margin-bottom-xs user-admin">
          <div><p>管理面积：</p><h4><b>{{ zongMianJi }}</b><span>m²</span></h4></div>
          <div><p>登记人口：</p><h4><b>{{ zongRenKou }}</b><span>人</span></h4></div>
          <div><p>房屋认证：</p><h4><b>{{ zongHuShu }}</b><span>户</span></h4></div>
          <div><p>从业年龄：</p><h4><b>{{ wordage }}</b><span>年</span></h4></div>
        </div>
        <div class="user-community flex align-center justify-between margin-bottom-xs">
          <div class="user-community-left">
            <p>负责小区：</p>
            <img src="../../../assets/img/louyu.png" alt="">
          </div>
          <div class="flex-sub flex align-center flex-wrap">
            <el-dropdown class="margin-right-xs margin-bottom-xs community-item" v-for="item in fuZeQuYu" :key="item.id">
              <span class="community-name">{{ item.xiaoqu_name }}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(items,j) in item.buildings" :key="j">{{ items}}号楼</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
        <div class="flex align-start justify-between  commend-table">
          <div class="table-box">
            <div><p class="active">表扬</p>
              <p>日期</p></div>
            <ul>
              <li v-for="(item,index) in biaoYang" :key="index"><p class="active">{{ item.content }}</p>
                <p>{{ item.create_time }}</p></li>

            </ul>
          </div>
          <div class="table-box">
            <div><p class="active">投诉</p>
              <p>日期</p></div>
            <ul>
              <li v-for="(item,index) in touSu" :key="index"><p class="active">{{ item.content }}</p>
                <p>{{ item.create_time }}</p></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right-info" v-if="one">
        <div class="right-num flex align-center justify-between flex-wrap margin-top-sm margin-bottom-sm">
          <div>业主签约率： <b>{{ one.yiQianHeTongLv }}%</b></div>
          <div>物业收缴率： <b>{{ one.yiJiaoFeiLv }}%</b></div>
          <div class="active">本月新增签约数： <b>{{ one.benYueXinZengHeTongShu }}户</b></div>
          <div class="active">缴费数户： <b>{{ one.yiJiaoFeiShu }}户</b></div>
        </div>
        <div class="right-tu margin-bottom-sm">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 签约率</span>
          </h3>

          <div id="qianyueLv" :style="{ width: '100%', height: '300px' }"></div>

        </div>
        <div class="right-fenxi">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 综合业务分析</span>
            <b>得分:{{ three.totle }}分</b>
          </h3>
          <div id="defen" style="width: 400px;height: 300px;margin: 0 auto;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {YGtongJiOne, YGtongJiTwo} from "@/api/tongji";
import {zhDate} from "@/utils/utils";
import {upFeil} from "@/config";
import * as echarts from 'echarts'
export default {
  name: "staff",
  data() {
    return {
      loading: false,
      name:'',
      avatar: '',
      year:'',
      month:'',
      zongMianJi:0,
      zongRenKou:0,
      zongHuShu:0,
      wordage:0,
      fuZeQuYu:[],
      biaoYang:[],
      touSu:[],
      one:[],
      two:[],
      three:[],
      time:new Date(),
    }
  },
  created() {
    this.year = zhDate(new Date(),4)
    this.month = zhDate(new Date(),5)
    this.init()
  },
  components: {},
  methods: {
    setMonth(e){
      this.time = e
      this.year = zhDate(new Date(e),4)
      this.month = zhDate(new Date(e),5)
      this.init()
    },
    async init() {
      this.loading = true
      let _data = await YGtongJiOne(this.$route.query.id, this.year,this.month)
      let _data2 = await YGtongJiTwo(this.$route.query.id, this.year,this.month)
      this.loading = false
      this.name = _data.data.name
      this.avatar = upFeil + '/' +_data.data.avatar
      this.zongMianJi = _data.data.zongMianJi
      this.zongRenKou = _data.data.zongRenKou
      this.zongHuShu = _data.data.zongHuShu
      this.wordage = _data.data.wordage
      this.fuZeQuYu = _data.data.fuZeQuYu
      this.biaoYang = _data.data.biaoYang
      this.touSu = _data.data.touSu
      this.one = _data2.data.one
      this.two = _data2.data.two
      this.three = _data2.data.three
      this.drawLine()
      this.drawRadar()
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('qianyueLv'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing:'cubicOut' ,
        tooltip: {
          trigger: 'axis'
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
            axisTick: {
              show: false//去除刻度线
            },
            axisLabel: {
              color: '#fff',//文本颜色
              // rotate:40
            },
            axisLine: {
              show: false//去除轴线
            },
            boundaryGap: false//去除轴内间距
          }
        ],

        yAxis: {
          // 数据作为刻度文字
          type: 'value',
          axisTick: {
            show: false//去除刻度线
          },
          axisLabel: {
            color: '#fff'//文本颜色
          },
          axisLine: {
            show: false//去除轴线
          },
          boundaryGap: false//去除轴内间距
        },

        //图例组件
        legend: {
          icon: 'rect',
          itemWidth: 14, itemHeight: 5, itemGap: 10,
          data: ['业主签约率'],
          right: '1px', top: '0px',
          textStyle: {fontSize: 12, color: '#fff5b3'}
        },


        // 设置网格样式
        grid: {
          show: true,// 显示边框
          top: '15%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          borderColor: '#fff',// 边框颜色
          containLabel: true // 包含刻度文字在内
        },
        toolbox: {
          show: false,
        },
        series: [
          {
            name: '业主签约率',
            data: this.two,
            type: 'line',
            color:'#ffa563'
          }
        ]
      });
    },
    drawRadar(){
      let myChart = echarts.init(document.getElementById('defen'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing:'cubicOut' ,
        tooltip: {},
        radar: {
          // shape: 'circle',
          indicator: [
            { name: '收费率', max: 100 },
            { name: '表彰', max: 100 },
            { name: '投诉', max: 100 },
            { name: '签约率', max: 100 },

          ]
        },

        series: [
          {
            type: 'radar',
            data: [
              {
                value: [this.three.yiJiaoFeiLv, this.three.biaoYangNum, this.three.touSuNum, this.three.yiQianHeTongLv],
                name: '综合业务分析'
              },
            ],
            color:'#ffa563',
            label: {
              show: true,
              formatter: function (params) {
                return params.value;
              }
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: 'rgba(255, 145, 124, 0.1)',
                  offset: 0
                },
                {
                  color: 'rgba(255, 145, 124, 0.9)',
                  offset: 1
                }
              ])
            }
          }
        ]
      })
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.container {
  background: url(../../../assets/img/bg_data.jpg) no-repeat top;
  background-size: 100% 100%;
  min-height: 100vh;
  min-width: 1900px;
  .loading {
    color: #ffffff;
    background: rgba(#000,.5);
    position: fixed;
    z-index: 99;
  }
  .top-box {
    height: 66px;

    .top-img-left {
      height: 66px;
      background: url("../../../assets/img/left-top.png") no-repeat top right;
    }

    .top-img-right {
      position: relative;
      height: 66px;
      background: url("../../../assets/img/right-top.png") no-repeat top left;
      .time-box{
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 24px;
        color: #ffdd99;
      }
    }

    .top-name {
      width: max-content;
      font-size: 40px;
      line-height: 66px;
      letter-spacing: 2px;
      padding: 0 30px;
      color: #ffffff;
      text-shadow: 0px 0px 7px rgba(52, 255, 204, 0.1);
      background: linear-gradient(-42deg,
        #ffd48a 0%,
        #fff5bb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .left-info {
    width: 630px;

    .left-user {
      h3 {
        height: 50px;
        color: #fff;
        font-size: 26px;
      }
    }

    .user-img {
      display: block;
      width: 166px;
      height: 215px;
      margin: 15px auto;
      background-color: #bc2a30;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        top: 8px;
        left: -8px;
      }
    }
    .manager-name{
      text-align: center;
      font-size: 26px;
      line-height: 50px;
      letter-spacing: 1px;
      color: #ffffff;

    }

    .user-admin {
      div {
        width: 149px;
        height: 102px;
        padding: 20px;
        border: solid 1px #cf464a;

        p {
          font-size: 18px;
          letter-spacing: 1px;
          color: #f9b09f;
          margin-bottom: 15px;
        }

        h4 {
          line-height: 150%;

          b {
            font-size: 24px;
            letter-spacing: 1px;
            color: #fff5b3;
          }

          span {
            font-size: 18px;
            color: #f9b09f;
          }
        }
      }
    }

    .user-community {
      padding: 20px;
      border: solid 1px #cf464a;

      .user-community-left {
        width: 150px;

        p {
          font-size: 18px;
          letter-spacing: 1px;
          color: #f9b09f;
        }
      }

      .community-item {
        cursor: pointer;

        .community-name {
          font-size: 16px;
          color: #fff5b3;
        }
      }

    }

    .commend-table {
      width: 100%;
      height: 420px;
      background-color: #9d2125;

      .table-box {
        width: 300px;

        div {
          display: flex;
          align-items: center;
          height: 50px;
          background-color: #a7292e;

          p {
            text-align: center;
            font-size: 18px;
            color: #ffffff;
            padding: 0 10px;
            width: 40%;
            line-height: 150%;

            &.active {
              width: 60%;
            }
          }
        }

        ul {
          height: 360px;
          overflow-y: auto;

          li {
            display: flex;
            align-items: center;
            background: #bc3235;
            min-height: 48px;
            border-bottom: 1px solid #e92f2f;

            p {
              text-align: center;
              font-size: 16px;
              color: #ffffff;
              padding: 5px;
              width: 40%;

              &.active {
                width: 60%;
              }
            }
          }
        }

      }
    }
  }

  .right-info {
    width: 1200px;

    .right-num {
      height: 140px;
      padding: 20px;
      border: solid 1px #cf464a;

      div {
        width: 50%;
        text-align: center;
        color: #ffa563;
        font-size: 30px;

        &.active {
          color: #ff6969;
        }

        b {
          color: #fff;

          span {
            font-size: 18px;
          }
        }
      }
    }

    .right-tu {
      height: 377px;
      padding: 20px;
      border: solid 1px #cf464a;

      h3 {
        font-size: 26px;
        color: #ffffff;
        height: 50px;
        line-height: 150%;
      }
    }

    .right-fenxi {
      height: 370px;
      padding: 20px;
      border: solid 1px #cf464a;

      h3 {
        font-size: 26px;
        color: #ffffff;
        height: 50px;
        line-height: 150%;
      }
    }
  }

}
</style>
